import { LinkWrapper } from "Explore/Components";
import styles from "./VenueCard.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Button, Grid } from "@mui/material";
import classNames from "classnames";
import FavoriteButton from "../FavoriteButton";

const VenueCard = ({ data, onKeywordClick, className, hideActions }) => {
  const statistics = [
    {
      icon: IconPack.citation,
      value: data.citation_count,
      title: "citations",
    },
    {
      icon: IconPack.publications,
      value: data.publication_count,
      title: "publications",
    },
    {
      icon: IconPack.h_index,
      value: data.h_index,
      title: "h-index",
    },
    {
      icon: IconPack.seniority,
      value: data.average_seniority,
      title: "average academic age",
    },
  ].filter((e) => !!e.value);

  return (
    <div className={classNames(styles["venue-card"], className)}>
      <div className={styles["venue-card__top"]}>
        <div className={styles["name--wrapper"]}>
          <LinkWrapper
            link={`/explore/venue/${data.id}`}
            component={
              <div className={classNames(styles["name"], styles["link"])}>
                <p>{data.name}</p>
              </div>
            }
          />

          {!hideActions && (
            <div className={styles["entity-actions"]}>
              <FavoriteButton
                isFavorited={data.is_favorited}
                itemId={data.id}
                itemType="venue"
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles["venue-card__body"]}>
        <Grid container className={styles["statistics"]}>
          {statistics.map((e, i) => (
            <Grid item xs className={styles["statistic"]} key={i}>
              {e.icon}
              <p>
                <span>{numberRegex(e.value)}</span> {e.title}
              </p>
            </Grid>
          ))}
        </Grid>
      </div>

      <div className={styles["venue-card__bottom"]}>
        {data.keywords && data.keywords.length > 0 && (
          <div className={styles["keywords"]}>
            <span>Research area: </span>
            {data.keywords.map((item, index) =>
              onKeywordClick ? (
                <Button
                  size="small"
                  key={index}
                  className={classNames(
                    styles["keywords--item"],
                    styles["clickable"]
                  )}
                  variant="contained"
                  onClick={() => onKeywordClick(item.value)}
                >
                  {item.rank && <b>#{item.rank}&nbsp;</b>}
                  {item.value}
                </Button>
              ) : (
                <div className={styles["keywords--item"]}>
                  {" "}
                  {item.rank && <b>#{item.rank}&nbsp;</b>}
                  {item.value}
                </div>
              )
            )}
          </div>
        )}

        <div className={styles["bio"]}>{data.bio}</div>
      </div>
      {/* <img
          src={data.photo_url ? data.photo_url : AlternativeImage.VENUE_LOGO}
          alt="venue-image"
        /> */}
    </div>
  );
};

export default VenueCard;
